import { useEffect } from 'react';

import useAuthStore from '@store/AuthStore';
import useStateSpotlightStore, { selectIsWaitingForDefaults } from '@store/StateSpotlightStore';
import { StateSpotlight, StateSpotlightPage } from '@interfaces/stateSpotlight';

interface UseStateSpotlightReturn {
  spotlight: StateSpotlight | null;
  isLoaded: boolean;
  shouldApplyDefaults: (page: StateSpotlightPage) => boolean;
  isWaitingForDefaults: (page: StateSpotlightPage) => boolean;
  markDefaultsApplied: (page: StateSpotlightPage) => void;
  hasCarriedFilters: (page: StateSpotlightPage) => boolean;
}

export const useStateSpotlight = (): UseStateSpotlightReturn => {
  const { spotlight, isLoaded, appliedDefaults, carriedFilters, loadSpotlight, markDefaultsApplied } =
    useStateSpotlightStore((state) => state);

  const initializedUser = useAuthStore((state) => state.initializedUser);
  const userId = useAuthStore((state) => state.authSession.userData?.userId);

  useEffect(() => {
    void loadSpotlight();
  }, [initializedUser, userId]);

  const shouldApplyDefaults = (page: StateSpotlightPage) => !!spotlight && !appliedDefaults[page];

  const isWaitingForDefaults = (page: StateSpotlightPage) =>
    selectIsWaitingForDefaults(page)({ isLoaded, spotlight, appliedDefaults });

  const hasCarriedFilters = (page: StateSpotlightPage) => carriedFilters[page];

  return { spotlight, isLoaded, shouldApplyDefaults, isWaitingForDefaults, markDefaultsApplied, hasCarriedFilters };
};
